<button type="submit" class="btn btn-primary">Button</button>